import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Situations from "./components/Situations";
import Testimonials from "./components/Testimonials";
import Accompaniment from "./components/Accompaniment";
import Services from "./components/Services";
import EstimationSimulator from "./components/EstimationSimulator";
import Gli from "./components/Gli";
import Contact from "./components/Contact";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import Estimation from "./pages/Estimation";
import HeroGallery from "./pages/HeroGallery";
import Quartier from "./pages/Quartier";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import { legalPages } from "./legal";
import { quartiers } from "./quartiers";
import { Toaster } from "./components/ui/toaster";
import { Seo } from "./components/Seo";

const Landing = () => (
  <div className="min-h-screen bg-[#F4F0E9]">
    <Header />
    <main>
      <Hero />
      <Services />
      <EstimationSimulator embedded />
      <Gli />
      <Accompaniment />
      <Situations />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer />
    </main>
    <Toaster />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Seo />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/estimation-loyer" element={<Estimation />} />
          <Route path="/galerie-photos" element={<HeroGallery />} />
          {quartiers.map((q) => (
            <Route key={q.slug} path={`/${q.slug}`} element={<Quartier q={q} />} />
          ))}
          {Object.entries(legalPages).map(([path, page]) => (
            <Route key={path} path={path} element={<Legal page={page} />} />
          ))}
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
